import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { pageContext, get } from 'ctm-util-functions';
import { resultsConfigSelector, selectedProductSelector } from 'ctm-selectors';
import { withRules } from '../../..';

import { onChange } from '../utils';

class _BadgeFilter extends Component {

    constructor(props) {
        super(props);
        this.formElementFactory = pageContext.getProps().factories.formElement;

        this.schema = this.getBadgeGroupSchema();
        this.extraProps = {};
        // this filter can be used as a staged filter - Energy bill period, or an unstaged filter - HnC bill period
        if (props.filterProps.fetchNewResults) {
            this.extraProps.onChange = (e) => { return onChange(e, props); };
        }
    }

    /**
     * Return the schema for the badgegroup used for the filters
     * @returns {Object} - The schema for the badgegroup used for the filters
     */
    getBadgeGroupSchema = () => {
        const { variant, filterProps } = this.props;
        const { options = [], resultsStateKey, resultsStagedStateKey, fetchNewResults, verticalName } = filterProps;

        // this can be used as a stage or an unstaged filter, if it's staged then fetchNewResults will be true and we use
        // the resultsStagedStateKey as the identifier, otherwise, use resultsStateKey, so that the updated values
        // are applied directly onto the results state
        const identifier = fetchNewResults ? resultsStagedStateKey : resultsStateKey;
        return {
            identifier,
            stateKey: 'vertical.quote',
            field: {
                type: 'badgegroup',
                metaType: 'radio',
                UIComponent: 'badge_primary_semi_rounded',
                labelVariant: 'inner_label_container_xsmall',
                values: options
            },
            variant,
            verticalName
        };
    };

    /**
     * Determine if the component should re-render based on the nextState
     * @param  {Object} nextProps  The incoming set of props
     * @returns {Boolean} true if the component should re-render
     */
    shouldComponentUpdate = (nextProps) => {
        const { selectedValue } = this.props;
        return selectedValue !== nextProps.selectedValue;
    };

    /**
     * Check visibility rules to see if there is one for this badge, if so return the visibility status
     * @returns {Boolean} - True if this badge should be visible
     */
    isVisible = () => {
        const rule = get(this.props, `rules.visibility_${get(this.props, 'optionProps.value')}`);
        return rule ? rule.result : true;
    };

    render = () => {
        const { dispatch, selectedValue, productCode } = this.props;
        if (this.schema.verticalName && this.schema.verticalName === 'CAR' && productCode && productCode === 'CARP') { // CARPEESH doesn't required Badgefilter
            return null;
        }
        if (!this.isVisible()) {
            return null;
        }
        return this.formElementFactory.createElement(this.schema, {}, false, dispatch, selectedValue, {}, null, this.extraProps);
    };

}

_BadgeFilter.propTypes = {
    filterProps: PropTypes.shape({
        // append to this, or change to string, if naming new filters
        filter: PropTypes.string.isRequired,
        showUpdateButton: PropTypes.bool,
        fetchNewResults: PropTypes.bool,
        formStateKey: PropTypes.string,
        resultsStateKey: PropTypes.string.isRequired,
        resultsStagedStateKey: PropTypes.string,
        verticalName: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                innerLabel: PropTypes.string,
                onClickActions: PropTypes.array
            })
        ).isRequired
    }).isRequired,
    selectedValue: PropTypes.string,
    dispatch: PropTypes.func,
    variant: PropTypes.string,
    productCode: PropTypes.string
};

/**
 * Map rules to our local component props
 * @param {Object} state - the application state
 * @param {object } props - the component props
 * @returns {Object} - the set of mapped props for the container
 */
const mapStateToProps = (state, props) => {
    const { resultsStateKey, resultsStagedStateKey, fetchNewResults } = props.filterProps;
    const identifier = fetchNewResults ? resultsStagedStateKey : resultsStateKey;
    const selectedValue = resultsConfigSelector(state).getIn(identifier.split('.'));
    const selectedProduct = selectedProductSelector(state);
    const productCode = selectedProduct.getIn(['providerMeta', 'code']);
    return {
        selectedValue,
        productCode
    };
};

export { _BadgeFilter };
export const BadgeFilter = withRules(connect(mapStateToProps)(_BadgeFilter));
